import React from "react";

import { ReviewSortOption } from "../../../models/reviews";
import { useAppDispatch, useAppSelector } from "../../reducers";
import { defaultState } from "../defaults";
import { updateSorting } from "../reducers";

import styles from "./SortingSelector.module.scss";

export const SortingSelector = () => {
    const dispatch = useAppDispatch();

    const sortOptions = useAppSelector(
        (state) => (state.reviews || defaultState).data.sortOptions,
    );
    const selectedSortOption = useAppSelector(
        (state) => (state.reviews || defaultState).ui.selectedSortOption,
    );

    return (
        <div className={styles.sortContainer}>
            <label htmlFor="review-sort">
                <span className={styles.selectPrefix}>Sort by:</span>
            </label>
            <select
                className={styles.sortList}
                value={selectedSortOption}
                onChange={(event) => {
                    dispatch(
                        updateSorting(
                            event.currentTarget.value as ReviewSortOption,
                        ),
                    );
                }}
                id="review-sort"
                name="review-sort"
            >
                {sortOptions.map((opt) => (
                    <option
                        key={opt.value}
                        value={opt.value}
                        className="customer-review__top-filters__sort-item"
                    >
                        {opt.label}
                    </option>
                ))}
            </select>
        </div>
    );
};
